import React from "react";
import { View } from "react-native";

import appStyles from "../../appStyles";
import Header from "../common/header";
import SetupChecklist from "../home/cards/onboarding/SetupChecklist";

export default class GetStartedPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      currentUser: this.controller.state?.currentUser,
    };
  }

  goBack = () => {
    this.controller.goBack();
  };

  render() {
    return (
      <View style={appStyles.container}>
        <Header
          title="Get Started"
          subTitle="Your checklist towards Time Mindfulness"
          hideAvatar
          goBack={this.goBack}
          controller={this.controller}
        />

        <SetupChecklist controller={this.controller} />
      </View>
    );
  }
}
